export default __webpack_public_path__ + "static/stickman-c252c77e0d594ee8d351953adc6bc354.png";